import COUNTRIES, { TCountry } from "utils/constants/countries.constants";
import { CUSTOM_FLAGS_USED_INSTEAD_OF_COUNTRY_FLAGS } from "./HealthAuthority.constants";

export const getHAName = (
  country: keyof TCountry,
  alias: string,
  t: (key: string, options: Record<string, string>) => string,
) => {
  const countryName = COUNTRIES[country]?.name;

  if (!countryName) {
    return country || alias;
  }

  return `${t(countryName, {
    ns: "common",
    keyPrefix: "countries",
  })} - ${alias}`;
};

export const getHAFlag = ({
  tenantId,
  country,
}: {
  tenantId?: string;
  country: keyof TCountry;
}) => {
  const flagBasedOnTenantIdAndCountryCode =
    CUSTOM_FLAGS_USED_INSTEAD_OF_COUNTRY_FLAGS.find(
      (entry) => entry.tenantId === tenantId && entry.country === country,
    );

  return flagBasedOnTenantIdAndCountryCode?.flag ?? COUNTRIES[country]?.flag;
};
